import ApplicationSerializer from 'eflex/serializers/application';

export default class SystemConfigurationSerializer extends ApplicationSerializer {
  attrs = {
    evision: {
      embedded: 'always',
    },
    jem: {
      embedded: 'always',
    },
    wie: {
      embedded: 'always',
    },
    singleSignOnConfig: {
      embedded: 'always',
    },
    kinetic: {
      embedded: 'always',
    },
  };
}
